import * as React from 'react';

import { BaseGameReconstructionConfigurationContext, frameworkBaseGameReconstruction } from './baseGameReconstructionconfiguration';

const withBaseGameReconstructionConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <BaseGameReconstructionConfigurationContext.Consumer>
            {(auth: any): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...frameworkBaseGameReconstruction} />
                );
            }}
        </BaseGameReconstructionConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withBaseGameReconstructionConfiguration;